import React from 'react';

interface ErrorWithRetryProps {
  message: string;
  onRetry: () => void;
  onStartNew?: () => void;
}

export const ErrorWithRetry: React.FC<ErrorWithRetryProps> = ({
  message,
  onRetry,
  onStartNew,
}) => {
  return (
    <div className="flex items-start gap-3 p-4 bg-red-50 border border-red-200 rounded-lg my-3">
      <div className="flex-shrink-0 flex items-center justify-center">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            stroke="#DC2626"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 8V12"
            stroke="#DC2626"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 16H12.01"
            stroke="#DC2626"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div className="flex-1 flex flex-col gap-3">
        <p className="m-0 text-sm text-red-800 leading-relaxed">{message}</p>
        <div className="flex gap-3 flex-wrap">
          <button
            type="button"
            className="inline-flex items-center gap-2 px-4 py-2 bg-[#012169] text-white border-none rounded-md text-sm font-medium cursor-pointer transition-colors hover:bg-[#001a4d] focus:outline-none focus:ring-2 focus:ring-[#012169]/30"
            onClick={onRetry}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 4V10H7"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M3.51 15C4.15839 16.8404 5.38734 18.4202 7.01166 19.5014C8.63598 20.5826 10.5677 21.1066 12.5157 20.9945C14.4637 20.8823 16.3226 20.1402 17.8121 18.8798C19.3017 17.6193 20.3413 15.909 20.7742 14.0064C21.2072 12.1037 21.0101 10.112 20.2126 8.33111C19.4152 6.55025 18.0605 5.07679 16.3528 4.13277C14.6451 3.18875 12.6769 2.82527 10.7447 3.09712C8.81245 3.36897 7.02091 4.26142 5.64 5.64L1 10"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Try Again
          </button>
          {onStartNew && (
            <button
              type="button"
              className="inline-flex items-center gap-2 px-4 py-2 bg-transparent text-[#012169] border border-[#012169] rounded-md text-sm font-medium cursor-pointer transition-all hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-[#012169]/30"
              onClick={onStartNew}
            >
              Start New Conversation
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorWithRetry;
